// src/integration/growth/crash.ts — crash / diagnostics adapter (Sentry).
//
// The orchestrator (index.ts) calls this ONLY once isGrowthSdkAllowed('crash') is green AND we're on a
// native platform. The real init is a dynamic import of @sentry/capacitor — added at ACTIVATION — so until
// that package is installed the web/dev bundle never references a native SDK and this is a verified no-op.

import type { GrowthInitResult } from './types';

export async function initCrash(): Promise<GrowthInitResult> {
  // ACTIVATION (when @sentry/capacitor is installed + consent + dataSafety green):
  //   const Sentry = await import('@sentry/capacitor');
  //   Sentry.init({ dsn: ADS_CONFIG.sentryDsn, tracesSampleRate: 0.05 });
  //   return { active: true, reason: 'sentry initialized' };
  return { active: false, reason: '@sentry/capacitor not installed (activation pending)' };
}
